import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { RouterService } from '../../../services/router/router.service';
import { APP_ROUTES } from '../../../utils/route.constant';
import { AuthDataService } from '../../../services/auth/auth-data.service';
import { DataService } from '../../../services/data/data.service';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { Ga4Service } from '../../../services/ga4/ga4.service';
import { ACC_LOGGEDOUT, FORGET_PASSWORD_PAGE, RESEND_EMAIL } from '../../../services/ga4/ga4.constant';

@Component({
  selector: 'app-email-confirm',
  templateUrl: './email-confirm.component.html',
  styleUrl: './email-confirm.component.scss'
})
export class EmailConfirmComponent implements OnInit, OnDestroy {
  @Input() title: string = '';
  @Input() message: string = '';
  @Input() isForPasswordReset: boolean = false;
  @Input() email?: string;
  initiatingReset: boolean = false;
  resetEmailCount: number = 0;
  cleaner$ = new Subject<void>();
  limitReached: boolean = false;
  emailSent$!: BehaviorSubject<{ error: boolean; message: string } | null>;

  constructor(private routerService: RouterService, private authData: AuthDataService, private data: DataService,private gaService: Ga4Service,) {
    this.emailSent$ = this.data.resetEmailSent$;
  }

  ngOnInit(): void {
    this.data.resetEmailSent$
      .pipe(takeUntil(this.cleaner$))
      .subscribe({
        next: (sent: { error: boolean; message: string } | null) => {
          if (!sent) return;
          if (!sent.error) {
            this.resetEmailCount++;
          } else {
            // this error is due to limit reached
            // sometimes doing too many requests lead to this error from auth0
            // so manually setting the limit reached to true
            this.limitReached = true;
            this.data.resetEmailSent$.next(null);
          }
          this.initiatingReset = false;
        }
      });
  }

  ngOnDestroy(): void {
    this.cleaner$.next();
    this.cleaner$.complete();
  }

  gotoRegister(): void {
    this.routerService.goto(APP_ROUTES.REGISTER);
  }

  gotoLogin(): void {
    this.routerService.goto(APP_ROUTES.LOGIN);
  }

  initiateReset(): void {
    this.data.resetEmailSent$.next(null);
     this.gaService.buttonClickEvent(FORGET_PASSWORD_PAGE, RESEND_EMAIL);
    if (!this.email || this.limitReached) { return; }
    this.initiatingReset = true;
    this.authData.resetPassword(this.email);
  }
}
